<template>
  <div class="bar_bar" :class="{ 'is-ipad': isIpad }">
    <div
      class="bar_item"
      :class="isSelect ? 'current_play' : ''"
      @click="() => toChildFn(item)"
    >
      <i :class="['font_family', `${item.icon}`]"></i>
      <p>{{ displayName }}</p>
      <span class="count-play" v-if="item.count && item.count > 0">
        {{ item.count > 99 ? '99+' : item.count }}
      </span>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { defineComponent } from 'vue'
import AppLink from './Link.vue'
import { sideBarStore } from '@/store/modules/sideBar.ts'
defineOptions({ name: 'SidebarItem' })
const sideStore = sideBarStore()
const isIpad = window.isIpad
const router = useRouter()
const props = defineProps({
  item: {
    type: Object,
    required: true,
  },
})
const smallScreenNameMap: Record<string, string> = {
  工作台: '看板',
  预约挂号: '挂号',
}
const displayName = computed(() => {
  if (!isIpad.value) return props.item.name
  return smallScreenNameMap[props.item.name] ?? props.item.name?.slice(0, 2)
})
const isSelect: any = computed(() => {
  return sideStore.componentName === props.item.componentName
})

const toChildFn = item => {
  router.push({ name: item.componentName ?? 'home' })
}
</script>
<style lang="scss" scoped>
.bar_bar {
  width: 100px;
  height: 90px;
  padding: 10px 10px;
  box-sizing: border-box;
}
.bar_item {
  position: relative;
  width: 80px;
  height: 80px;
  padding: 10px 0;
  font-size: 16px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  cursor: pointer;
  i {
    font-size: 24px;
  }
  p {
    margin: 0;
    margin-top: 5px;
  }
  .count-play {
    min-width: 20px;
    height: 20px;
    box-sizing: border-box;
    position: absolute;
    top: 5px;
    right: 5px;
    background-color: var(--red);
    color: var(--white-text);
    padding: 0 5px;
    border-radius: 12px;
    font-size: 12px;
    font-weight: 400;
    text-align: center;
  }
}
.bar_item:hover {
  background-color: var(--defalut-bgc);
  border-radius: 6px;
}
.current_play {
  transition-property: all;
  transition-duration: 0.1s;
  box-sizing: border-box;
  background-color: var(--light-brown) !important;
  color: var(--brown);
  font-weight: 600;
  border-radius: 6px;
}

.bar_bar.is-ipad {
  width: 64px;
  height: 64px;
  padding: 6px;

  .bar_item {
    width: 52px;
    height: 52px;
    padding: 0;

    i {
      font-size: 24px;
    }

    p {
      display: block;
      margin-top: 2px;
      font-size: 11px;
      line-height: 14px;
      white-space: nowrap;
    }

    .count-play {
      min-width: 18px;
      height: 18px;
      top: 2px;
      right: 2px;
      padding: 0 4px;
      line-height: 18px;
      font-size: 11px;
    }
  }
}
</style>
